import { makeStyles } from '@fluentui/react-components';
import { DatabaseRegular } from '@fluentui/react-icons';
import { useOrgContext, type OrgId } from './DataverseOrgProvider';
import { COLORS } from '@shared/ui';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '4px 12px',
  },
  orgLabel: {
    fontSize: '11px',
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  devIndicator: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    flexShrink: 0,
  },
  prodDot: {
    backgroundColor: '#4caf50',
  },
  devDot: {
    backgroundColor: '#ff9800',
  },
});

interface OrgSwitcherProps {
  variant?: 'dark' | 'light';
}

export function OrgSwitcher({ variant = 'dark' }: OrgSwitcherProps) {
  const styles = useStyles();
  const { activeOrg, setActiveOrg, orgLabel, hasDevOrg } = useOrgContext();
  const isDark = variant === 'dark';

  const handleToggle = (org: OrgId) => {
    setActiveOrg(org);
  };

  const iconColor = isDark ? 'rgba(255,255,255,0.7)' : COLORS.textSecondary;
  const labelColor = isDark ? 'rgba(255,255,255,0.6)' : COLORS.textSecondary;
  const btnColor = isDark ? 'rgba(255,255,255,0.6)' : COLORS.textSecondary;
  const btnActiveColor = isDark ? '#ffffff' : COLORS.textPrimary;
  const btnActiveBg = isDark ? 'rgba(255,255,255,0.2)' : COLORS.bgElevated;
  const borderColor = isDark ? 'rgba(255,255,255,0.25)' : COLORS.border;

  return (
    <div className={styles.container}>
      <DatabaseRegular style={{ fontSize: '16px', color: iconColor }} />
      {hasDevOrg ? (
        <>
          <div style={{
            display: 'flex', borderRadius: '4px', overflow: 'hidden',
            border: `1px solid ${borderColor}`,
          }}>
            <button
              onClick={() => handleToggle('prod')}
              style={{
                padding: '3px 12px', fontSize: '12px', cursor: 'pointer', border: 'none',
                fontWeight: activeOrg === 'prod' ? '600' : '500',
                backgroundColor: activeOrg === 'prod' ? btnActiveBg : 'transparent',
                color: activeOrg === 'prod' ? btnActiveColor : btnColor,
              }}
            >
              PROD
            </button>
            <button
              onClick={() => handleToggle('dev')}
              style={{
                padding: '3px 12px', fontSize: '12px', cursor: 'pointer', border: 'none',
                fontWeight: activeOrg === 'dev' ? '600' : '500',
                backgroundColor: activeOrg === 'dev' ? btnActiveBg : 'transparent',
                color: activeOrg === 'dev' ? btnActiveColor : btnColor,
              }}
            >
              DEV
            </button>
          </div>
          <div
            className={`${styles.devIndicator} ${activeOrg === 'prod' ? styles.prodDot : styles.devDot}`}
          />
        </>
      ) : null}
      <span className={styles.orgLabel} style={{ color: labelColor }}>{orgLabel}</span>
    </div>
  );
}
